var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-tool-tip',{staticClass:"info-tooltip",attrs:{"icon-path":"/images/info-icon-blue.svg"}},[_c('div',[_c('span',{staticClass:"ri-bold-label"},[_vm._v("עבור משתמשי iPhone,")]),_vm._v(" "),_c('span',[_vm._v("יש לחבר את החשבון באמצעות דפדפן Safari או מהמחשב")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }